module.exports = require("pretty-error");


//////////////////
// WEBPACK FOOTER
// external "pretty-error"
// module id = 21
// module chunks = 0